import { useEffect, useMemo, useState } from "react";
import {
  useKnowledgeSources,
  useKnowledgeSourcesLoading,
} from "../../../adapters/deep-research/state/hooks/stateHooks.ts";
import { useDeepResearchService } from "../../../adapters/deep-research/state/hooks/useDeepResearchService.tsx";
import { useFeatureFlagValue } from "../../../config/FeatureFlagManager/hooks.ts";
import {
  KnowledgeSource,
  KnowledgeSourceDropdown,
} from "../../../feature-components/KnowledgeSourceDropdown/KnowledgeSourceDropdown.tsx";
import { FileUploadTermsModal } from "../../../feature-components/TermsAndConditions/FileUploadTermsModal.tsx";

export const ConnectedKnowledgeSourceDropdown = (props: {
  selectedSource: KnowledgeSource | undefined;
  onSourceSelect: (source: KnowledgeSource | undefined) => void;
}) => {
  const appService = useDeepResearchService();
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    appService.refreshKnowledgeSources().then();
  }, [appService]);

  const knowledgeSources = useKnowledgeSources();
  const knowledgeSourcesLoading = useKnowledgeSourcesLoading();
  const enableIngestionFolderLink = useFeatureFlagValue(
    "enableIngestionFolderLink",
  );
  const enableTermsAndConditions = useFeatureFlagValue(
    "enableTermsAndConditions",
  );
  const enableChatFirstPage = useFeatureFlagValue("enableChatFirstPage");

  const knowledgeSourceOptions = useMemo(
    () =>
      knowledgeSources.map((source) => ({
        value: source.name,
        label: source.name,
        repoUrl: source.repoUrl,
      })),
    [knowledgeSources],
  );

  const handleAddFilesClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (enableTermsAndConditions) {
      setShowTermsModal(true);
    } else if (props.selectedSource?.repoUrl) {
      window.open(
        props.selectedSource.repoUrl,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const handleTermsAccept = () => {
    setShowTermsModal(false);
    if (props.selectedSource?.repoUrl) {
      window.open(
        props.selectedSource.repoUrl,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const handleTermsCancel = () => {
    setShowTermsModal(false);
  };

  const featureFlags = useMemo(
    () => ({
      enableIngestionFolderLink,
      enableChatFirstPage,
    }),
    [enableIngestionFolderLink, enableChatFirstPage],
  );

  return (
    <>
      <KnowledgeSourceDropdown
        knowledgeSourcesLoading={knowledgeSourcesLoading}
        knowledgeSources={knowledgeSourceOptions}
        selectedSource={props.selectedSource}
        onSelect={(value) => {
          const selected = knowledgeSourceOptions.find(
            (source) => source.value === value[0],
          );
          props.onSourceSelect(selected);
        }}
        featureFlags={featureFlags}
        onClick={handleAddFilesClick}
        showLabel={false}
      />
      <FileUploadTermsModal
        open={showTermsModal}
        onAccept={handleTermsAccept}
        onCancel={handleTermsCancel}
      />
    </>
  );
};
